export const pets = [
    {
        id: 1,
        name: 'Shiwawa',
        location: 'Nigeria',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 2,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 3,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 4,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 5,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 6,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 7,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 8,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 9,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 10,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 11,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
    {
        id: 12,
        name: 'Pows Shelters',
        location: 'South Carolina',
        image: '_placeholderImage.png',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Max',

    },
]

export const breeder = [
    {
        id: 1,
        name: 'Pawis',
        location: 'Nigeria',
        image: 'breeder.jpg',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Charlotte',

    },
    {
        id: 2,
        name: 'All dogs',
        location: 'South Carolina',
        image: 'ricky.jpg',
        breed: 'Large breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Ricky',

    },
    {
        id: 3,
        name: 'Awesome pets',
        location: 'South Carolina',
        image: 'breeder.jpg',
        breed: 'Mixed breed',
        age: '2 years',
        gender: 'Male',
        description: 'This impressive paella is a perfect party dish and a fun meal to cook together.',
        breeder: 'Pamela',

    },
]


export const messages = [
    {
      id: 1,
      primary: 'Brunch this week?',
      secondary: "I'll be in the neighbourhood this week. Let's grab a bite to eat",
      person: '/static/images/avatar/5.jpg',
    },
    {
      id: 2,
      primary: 'Birthday Gift',
      secondary: `Do you have a suggestion for a good present for John on his work
        anniversary. I am really confused & would love your thoughts on it.`,
      person: '/static/images/avatar/1.jpg',
    },
    {
      id: 3,
      primary: 'Recipe to try',
      secondary: 'I am try out this new BBQ recipe, I think this might be amazing',
      person: '/static/images/avatar/2.jpg',
    },
    {
      id: 4,
      primary: 'Yes!',
      secondary: 'I have the tickets to the ReactConf for this year.',
      person: '/static/images/avatar/3.jpg',
    },
    {
      id: 5,
      primary: "Doctor's Appointment",
      secondary: 'My appointment for the doctor was rescheduled for next Saturday.',
      person: '/static/images/avatar/4.jpg',
    },
    {
      id: 6,
      primary: 'Discussion',
      secondary: `Menus that are generated by the bottom app bar (such as a bottom
        navigation drawer or overflow menu) open as bottom sheets at a higher elevation
        than the bar.`,
      person: '/static/images/avatar/5.jpg',
    },
    {
      id: 7,
      primary: 'Summer BBQ',
      secondary: `Who wants to have a cookout this weekend? I just got some furniture
        for my backyard and would love to fire up the grill.`,
      person: '/static/images/avatar/1.jpg',
    },
  ];

  export const top100Films = [
      { name: 'The Shawshank Redemption', year: 1994 },
      { name: 'The Godfather', year: 1972 },
      { name: 'The Godfather: Part II', year: 1974 },
      { name: 'The Dark Knight', year: 2008 },
      { name: '12 Angry Men', year: 1957 },
      { name: "Schindler's List", year: 1993 },
      { name: 'Pulp Fiction', year: 1994 },
      {
        name: 'The Lord of the Rings: The Return of the King',
        year: 2003,
      },
      { name: 'The Good, the Bad and the Ugly', year: 1966 },
      { name: 'Fight Club', year: 1999 },
      {
        name: 'The Lord of the Rings: The Fellowship of the Ring',
        year: 2001,
      },
      {
        name: 'Star Wars: Episode V - The Empire Strikes Back',
        year: 1980,
      },
      { name: 'Forrest Gump', year: 1994 },
      { name: 'Inception', year: 2010 },
      {
        name: 'The Lord of the Rings: The Two Towers',
        year: 2002,
      },
      { name: "One Flew Over the Cuckoo's Nest", year: 1975 },
      { name: 'Goodfellas', year: 1990 },
      { name: 'The Matrix', year: 1999 },
      { name: 'Seven Samurai', year: 1954 },
      {
        name: 'Star Wars: Episode IV - A New Hope',
        year: 1977,
      },
      { name: 'City of God', year: 2002 },
      { name: 'Se7en', year: 1995 },
      { name: 'The Silence of the Lambs', year: 1991 },
      { name: "It's a Wonderful Life", year: 1946 },
      { name: 'Life Is Beautiful', year: 1997 },
      { name: 'The Usual Suspects', year: 1995 },
      { name: 'Léon: The Professional', year: 1994 },
      { name: 'Spirited Away', year: 2001 },
      { name: 'Saving Private Ryan', year: 1998 },
      { name: 'Once Upon a Time in the West', year: 1968 },
      { name: 'American History X', year: 1998 },
      { name: 'Interstellar', year: 2014 },
      { name: 'Casablanca', year: 1942 },
      { name: 'City Lights', year: 1931 },
      { name: 'Psycho', year: 1960 },
      { name: 'The Green Mile', year: 1999 },
      { name: 'The Intouchables', year: 2011 },
      { name: 'Modern Times', year: 1936 },
      { name: 'Raiders of the Lost Ark', year: 1981 },
      { name: 'Rear Window', year: 1954 },
      { name: 'The Pianist', year: 2002 },
      { name: 'The Departed', year: 2006 },
      { name: 'Terminator 2: Judgment Day', year: 1991 },
      { name: 'Back to the Future', year: 1985 },
      { name: 'Whiplash', year: 2014 },
      { name: 'Gladiator', year: 2000 },
      { name: 'Memento', year: 2000 },
      { name: 'The Prestige', year: 2006 },
      { name: 'The Lion King', year: 1994 },
      { name: 'Apocalypse Now', year: 1979 },
      { name: 'Alien', year: 1979 },
      { name: 'Sunset Boulevard', year: 1950 },
      {
        name: 'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
        year: 1964,
      },
      { name: 'The Great Dictator', year: 1940 },
      { name: 'Cinema Paradiso', year: 1988 },
      { name: 'The Lives of Others', year: 2006 },
      { name: 'Grave of the Fireflies', year: 1988 },
      { name: 'Paths of Glory', year: 1957 },
      { name: 'Django Unchained', year: 2012 },
      { name: 'The Shining', year: 1980 },
      { name: 'WALL·E', year: 2008 },
      { name: 'American Beauty', year: 1999 },
      { name: 'The Dark Knight Rises', year: 2012 },
      { name: 'Princess Mononoke', year: 1997 },
      { name: 'Aliens', year: 1986 },
      { name: 'Oldboy', year: 2003 },
      { name: 'Once Upon a Time in America', year: 1984 },
      { name: 'Witness for the Prosecution', year: 1957 },
      { name: 'Das Boot', year: 1981 },
      { name: 'Citizen Kane', year: 1941 },
      { name: 'North by Northwest', year: 1959 },
      { name: 'Vertigo', year: 1958 },
      {
        name: 'Star Wars: Episode VI - Return of the Jedi',
        year: 1983,
      },
      { name: 'Reservoir Dogs', year: 1992 },
      { name: 'Braveheart', year: 1995 },
      { name: 'M', year: 1931 },
      { name: 'Requiem for a Dream', year: 2000 },
      { name: 'Amélie', year: 2001 },
      { name: 'A Clockwork Orange', year: 1971 },
      { name: 'Like Stars on Earth', year: 2007 },
      { name: 'Taxi Driver', year: 1976 },
      { name: 'Lawrence of Arabia', year: 1962 },
      { name: 'Double Indemnity', year: 1944 },
      {
        name: 'Eternal Sunshine of the Spotless Mind',
        year: 2004,
      },
      { name: 'Amadeus', year: 1984 },
      { name: 'To Kill a Mockingbird', year: 1962 },
      { name: 'Toy Story 3', year: 2010 },
      { name: 'Logan', year: 2017 },
      { name: 'Full Metal Jacket', year: 1987 },
      { name: 'Dangal', year: 2016 },
      { name: 'The Sting', year: 1973 },
      { name: '2001: A Space Odyssey', year: 1968 },
      { name: "Singin' in the Rain", year: 1952 },
      { name: 'Toy Story', year: 1995 },
      { name: 'Bicycle Thieves', year: 1948 },
      { name: 'The Kid', year: 1921 },
      { name: 'Inglourious Basterds', year: 2009 },
      { name: 'Snatch', year: 2000 },
      { name: '3 Idiots', year: 2009 },
      { name: 'Monty Python and the Holy Grail', year: 1975 },
    ];